import React, { useState, useEffect, useRef, useCallback } from "react";
import bannerImg from "../assets/images/House5.jpg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowRight,
  faArrowRightLong,
  faAward,
  faBath,
  faBed,
  faEnvelope,
  faLocationDot,
  faMagnifyingGlass,
  faPhone,
  faStar,
} from "@fortawesome/free-solid-svg-icons";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay, EffectFade, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/effect-fade";
import avatar1 from "../assets/images/avatar1.png";
import avatar2 from "../assets/images/avatar3.png";
import placeholder from "../assets/images/house-placeholder.webp";
import { Link } from "react-router-dom";
import imgs from "./temp.json";
import ReactImageGallery from "react-image-gallery";
import calc from "../assets/images/shutterstock_2489188913-min.jpg";
import report from "../assets/images/shutterstock_699442570-min.jpg";

import house2 from "../assets/images/shutterstock_2200985705-min.jpg";
import constants from "../constants/constants";
import useUserParams from "../hooks/useUserParams";
import globalState from "../utils/globalState";
import video from "../assets/images/2110972-uhd_3840_2160_30fps.mp4";
// import video from '../assets/images/1107548377-preview.mp4'
import formattingFunctions from "../functions/formatting";
import houseInterior from "../assets/images/shutterstock_2304013113-min.jpg";
// import houseInterior from "../assets/images/stock-photo-luxury-hotel-bathroom-interior-with-bathtub-and-side-table-concrete-floor-bathing-space-in-modern-2467634645.jpg"

import houseInterior2 from "../assets/images/shutterstock_1935730303-min.jpg";
import Particles, { initParticlesEngine } from "@tsparticles/react";
import { loadSlim } from "@tsparticles/slim"; // if you are going to use `loadSlim`, install the "@tsparticles/slim" package too.
import ParallaxCard from "react-parallax-card";
import pageSEO from "../constants/pageSEO";
import SEO from "./seo.component";
import isReactSnap from "../utils/isReactSnap";
import DEMO_LISTINGS from "../constants/demoListings";

// Function to get image from assets/images folder based on ListingKey
function getListingImage(listingKey) {
  if (!listingKey) return placeholder;
  
  try {
    // Use require.context to get all images from the images folder
    const imageContext = require.context('../assets/images', false, /\.(jpg|jpeg|png|webp)$/i);
    const imageKeys = imageContext.keys();
    
    // Find images that contain the ListingKey in their filename
    const matchingImages = imageKeys.filter(key => {
      const fileName = key.toLowerCase();
      const listingKeyLower = listingKey.toLowerCase();
      return fileName.includes(listingKeyLower);
    });
    
    if (matchingImages.length === 0) {
      return placeholder;
    }
    
    // Prioritize "main photo" images, otherwise return the first match
    const mainPhoto = matchingImages.find(key => key.toLowerCase().includes('main photo'));
    if (mainPhoto) {
      return imageContext(mainPhoto);
    }
    
    // Return the first matching image
    return imageContext(matchingImages[0]);
  } catch (error) {
    console.error('Error loading listing image:', error);
    return placeholder;
  }
}

export default function Homepage() {
  const contact = useRef();
  const { getAllUserParams } = useUserParams();
  const {
    agentName,
    agentNumber,
    agentEmail,
    about,
    headshot
  } = getAllUserParams();
  const colours = [
    "#9e7aff",
    "#ff7aff",
    "#fe8bbb",
    "#fe8b8b",
    "#ffbd7a",
    "#f7ab5f",
  ];

  const [listings, setListings] = useState([]);
  const [media, setMedia] = useState(imgs.thumbs.value);
  const [formatted, setFormatted] = useState({});
  const loaded = useRef(false);
  const loadedRef = useRef(false);
  const [windowSize, setWindowSize] = useState(window.innerWidth);
  const testimonials = useRef();
  const [formData, setFormData] = useState({
    Name: "",
    "Email Address": "",
    Message: "",
  });
  const [formErrors, setFormErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  const getURLParameters = () => {
    const urlParams = new URLSearchParams(window.location.search);
    return {
      userId: urlParams.get("userId"),
    };
  };

  const onWindowResize = () => {
    setWindowSize(window.innerWidth);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    // Clear error when user starts typing
    if (formErrors[name]) {
      setFormErrors(prev => ({ ...prev, [name]: "" }));
    }
  };

  // Email validation function
  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  // Form validation function
  const validateForm = () => {
    const errors = {};
    
    // Check if Name is empty
    if (!formData.Name.trim()) {
      errors.Name = "Name is required";
    }
    
    // Check if Email is empty and valid format
    if (!formData["Email Address"].trim()) {
      errors["Email Address"] = "Email is required";
    } else if (!validateEmail(formData["Email Address"])) {
      errors["Email Address"] = "Please enter a valid email address";
    }
    
    // Check if Message is empty
    if (!formData.Message.trim()) {
      errors.Message = "Message is required";
    }
    
    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  async function submitForm(event) {
    event.preventDefault();
    
    // Validate form before submission
    if (!validateForm()) {
      return;
    }
    
    setIsSubmitting(true);

    const json = JSON.stringify({
      ...formData,
      access_key: constants.EMAIL_ACCESS_KEY,
      subject: "New Contact Form Message",
    });

    try {
      const res = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: json,
      });

      const data = await res.json();

      if (data?.success) {
        console.log("Success", data);
        // Clear form after successful submission
        setFormData({
          Name: "",
          "Email Address": "",
          Message: "",
        });
        setFormErrors({});
        alert("Thanks for your message! We will get back to you as soon as possible.");
      } else {
        alert("We encountered an error in sending this message. Please try again later.");
      }
    } catch (err) {
      console.log(err);
      alert("We encountered an error in sending this message. Please try again later.");
    }
    
    setIsSubmitting(false);
  }

  useEffect(() => {
    window.addEventListener("resize", onWindowResize);
    return () => {
      window.removeEventListener("resize", onWindowResize);
    };
  }, []);

  function getData() {
    // Skip API calls during static generation
    if (isReactSnap()) {
      return Promise.resolve({ value: [] });
    }

    var body = {
      url: `https://query.ampre.ca/odata/Property?$filter=(ListAgentKey eq '${constants.AGENT_ID}' and StandardStatus eq 'Active')&$orderby=OriginalEntryTimestamp desc,ListingKey&$top=12`,
      needAuth: true,
      bearerToken: constants.TOKEN,
    };

    return new Promise(async (resolve, reject) => {
      try {
        let request = `odata/Property(Q)$filter=(ListAgentKey(S)eq(S)\'${constants.AGENT_ID}\'(S)and(S)StandardStatus(S)eq(S)\'Active\')(A)$orderby=OriginalEntryTimestamp(S)desc,ListingKey(A)$top=12`;


        let data =
          constants.ENVIRONMENT === "production"
            ? await fetch(`https://${constants.DOMAIN}/api/${request}`)
            : await fetch(`http://${constants.URL}/metaGet`, {
              method: "POST",
              body: JSON.stringify(body),
              headers: {
                "Content-Type": "application/json",
              },
            });

        if (data.ok) {
          let res = await data.json();
          // Check if we have valid data
          if (res && res.value && res.value.length > 0) {
            resolve(res);
          } else {
            // Return demo data if API returns empty result
            console.warn("API returned empty data, using demo listings");
            resolve({ value: DEMO_LISTINGS });
          }
        } else {
          // Return demo data if API call fails
          console.warn("API call failed, using demo listings");
          resolve({ value: DEMO_LISTINGS });
        }
      } catch (err) {
        // Return demo data on error
        console.warn("Error fetching listings, using demo data:", err);
        resolve({ value: DEMO_LISTINGS });
      }
    });
  }

  function getMedia(listings) {
    // Skip API calls during static generation
    if (isReactSnap() || !listings || listings.length === 0) {
      return Promise.resolve({ value: [] });
    }

    // this is for development
    //var temp = `https://query.ampre.ca/odata/Media?$filter=(`

    // this is for production
    // var temp = `odata/Media?$filter=(`

    if (constants.ENVIRONMENT === "development") {
      var temp = `https://query.ampre.ca/odata/Media?$filter=ResourceRecordKey in (`;
      for (let l of listings) {
        temp = temp + "'" + l.ListingKey + "', ";
      }
      temp = temp.slice(0, -2);
      temp =
        temp +
        ") and ImageSizeDescription eq 'Medium' and PreferredPhotoYN eq true";
    } else {
      var temp = `odata/Media(Q)$filter=ResourceRecordKey(S)in(S)(`;
      for (let l of listings) {
        temp = temp + "'" + l.ListingKey + "',";
      }
      temp = temp.slice(0, -1);
      temp =
        temp +
        ")(S)and(S)ImageSizeDescription(S)eq(S)'Medium'(S)and(S)PreferredPhotoYN(S)eq(S)true";
    }
    var body = {
      url: temp,
      needAuth: true,
      bearerToken: constants.TOKEN,
      // Accept: 'application/json',
      // Authorization: 'Bearer eyJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ2ZW5kb3IvdHJyZWIvNjUyMCIsImF1ZCI6IkFtcFVzZXJzUHJkIiwicm9sZXMiOlsiQW1wVmVuZG9yIl0sImlzcyI6InByb2QuYW1wcmUuY2EiLCJleHAiOjI1MzQwMjMwMDc5OSwiaWF0IjoxNzMwMjI1OTA1LCJzdWJqZWN0VHlwZSI6InZlbmRvciIsInN1YmplY3RLZXkiOiI2NTIwIiwianRpIjoiMGYyMjk3OTY1Y2NjN2U4MSIsImN1c3RvbWVyTmFtZSI6InRycmViIn0.BMvVrtwah8swIzW38UMs6yKF-HM4QO0bZu81blYx6J4'
    };

    return new Promise(async (resolve, reject) => {
      try {
        let data =
          constants.ENVIRONMENT === "production"
            ? await fetch(`https://${constants.DOMAIN}/api/${temp}`)
            : await fetch(`http://${constants.URL}/metaGet`, {
              method: "POST",
              body: JSON.stringify(body),
              headers: {
                "Content-Type": "application/json",
              },
            });

        if (data.ok) {
          let res = await data.json();
          resolve(res);
        } else {
          reject("Failed to fetch data");
        }
      } catch (err) {
        reject(err);
      }
    });
  }

  function formatMedia(media) {
    var temp = {};

    for (let img of media) {
      if (temp[img.ResourceRecordKey]) {
        temp[img.ResourceRecordKey] = [...temp[img.ResourceRecordKey], img];
      } else {
        temp[img.ResourceRecordKey] = [img];
      }
    }
    return temp;
  }

  const fetchTemplateSettings = async (userId) => {
    try {
      const apiKey = process.env.REACT_APP_API_KEY;
      const response = await fetch(
        `https://agent.proagentsolutions.com/MongoDB/GetTemplateSettingsByUserId?userId=${userId}&apiKey=${apiKey}`
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const templateSettings = await response.json();
      console.log("Template settings fetched:", templateSettings);

      if (templateSettings) {
        const settingsData = templateSettings.data || templateSettings;

        const mappedUserData = {
          userId: userId,
          agentName: settingsData.agentName || settingsData.AGENT_NAME,
          agentTitle: settingsData.agentTitle || settingsData.AGENT_TITLE,
          agentNumber: settingsData.agentNumber || settingsData.AGENT_NUMBER,
          agentEmail: settingsData.agentEmail || settingsData.AGENT_EMAIL,
          brokerage: settingsData.brokerage || settingsData.BROKERAGE,
          ...settingsData,
        };

        globalState.setUserData(mappedUserData);

        console.log("Template settings data:", settingsData);
        console.log(
          "Template settings mapped to user data:",
          mappedUserData
        );
      }

      return templateSettings;
    } catch (error) {
      console.error("Error fetching template settings:", error);
      return null;
    }
  };

  useEffect(() => {
    if (!loaded.current) {
      const urlParams = getURLParameters();
      if (urlParams.userId) {
        globalState.setUserId(urlParams.userId);

        fetchTemplateSettings(urlParams.userId).then(() => {
          console.log(
            "Global State Updated with Template Settings:",
            globalState.getDebugInfo()
          );
        });

        console.log("Global State Updated:", globalState.getDebugInfo());
      }

      var temp1 = [];
      getData()
        .then((data) => {
          setListings(data.value);
          getMedia(data.value)
            .then((d) => {
              setMedia(d.value);
              temp1 = d.value;
              setFormatted(formatMedia(d.value));
            })
            .catch((err) => {
              console.log(err);
            });
        })
        .catch((err) => {
          console.log(err);
        });

      loaded.current = true;
    }
  }, []);

  function slugify(str) {
    str = str.replace(/^\s+|\s+$/g, "");
    str = str.toLowerCase();
    str = str
      .replace(/[^a-z0-9 -]/g, "")
      .replace(/\s+/g, "-")
      .replace(/-+/g, "-");
    return str;
  }

  const [keyword, setKeyword] = useState("");

  const [init, setInit] = useState(false);

  // this should be run only once per application lifetime
  useEffect(() => {
    initParticlesEngine(async (engine) => {
      // you can initiate the tsParticles instance (engine) here, adding custom shapes or presets
      // this loads the tsparticles package bundle, it's the easiest method for getting everything ready
      // starting from v2 you can add only the features you need reducing the bundle size
      //await loadAll(engine);
      //await loadFull(engine);
      await loadSlim(engine);
      //await loadBasic(engine);
    }).then(() => {
      setInit(true);
    });
  }, []);

  const particlesLoaded = (container) => {};

  const seoConfig = pageSEO.home();
  return (
    <div>
      <SEO {...seoConfig} />
      {init && (
        <Particles
          id="tsparticles"
          particlesLoaded={particlesLoaded}
          options={{
            background: {
              color: {
                value: "#050520",
              },
            },
            fpsLimit: 120,
            interactivity: {
              events: {
                onClick: {
                  enable: true,
                  mode: "push",
                },
                onHover: {
                  enable: true,
                  mode: "attract",
                },
                resize: true,
              },
              modes: {
                push: {
                  quantity: 4,
                },
                repulse: {
                  distance: 200,
                  duration: 0.4,
                },
              },
            },
            particles: {
              color: {
                value: "#ffbd7a",
              },
              links: {
                color: "#ffffff",
                distance: 150,
                enable: false,
                opacity: 0.5,
                width: 1,
              },
              move: {
                direction: "none",
                enable: true,
                outModes: {
                  default: "bounce",
                },
                random: false,
                speed: 1,
                straight: false,
              },
              number: {
                density: {
                  enable: true,
                  area: 800,
                },
                value: 80,
              },
              opacity: {
                value: 0.5,
              },
              shape: {
                type: "circle",
              },
              size: {
                value: { min: 1, max: 3 },
              },
            },
            detectRetina: true,
          }}
        />
      )}
      )
      <div className="w-full  h-[100vh] relative bg-cover ">
        <div className="mx-auto  pt-[35%] md:pt-[25%] lg:pt-[12%] px-5 z-10 relative">
          <h1 className="sm:text-6xl min-[425px]:text-5xl text-4xl text-center pb-12 libre text-gradient text-unset">
            Experience You Can Trust
          </h1>
          <div className="flex gap-6 justify-center">
            {/* <div className="relative flex-1">
                            <input className="form-input" placeholder="Search Keyword" value={keyword} onChange={(e) => setKeyword(e.target.value)} style={{ borderRadius: '99999px' }}></input>
                            <FontAwesomeIcon icon={faMagnifyingGlass} className="absolute right-4 top-2 text-med-grey" />
                        </div> */}
            <Link>
              <button
                onClick={() => contact.current?.scrollIntoView()}
                className="btn-primary"
              >
                Contact Me
              </button>
            </Link>
            <Link to={"/listings"}>
              <button className="btn-tertiary">See Listings</button>
            </Link>
          </div>
        </div>
        <img
          src={constants.HOME_IMAGE}
          className="absolute bottom-[-8%] translate-x-[-50%] left-[50%] md:h-[80vh] md:w-auto h-[70vh]"
        ></img>
        {/* <div className="absolute bottom-[-8%] md:h-[80vh] md:w-auto w-[90vw] flex justify-center overflow-clip md:overflow-visible left-[50%] translate-x-[-50%]">

                    <img src={house} className="w-full h-full object-cover md:h-[80vh] md:w-auto md:object-none"></img>
                </div> */}
        <svg
          className="z-10 fill-logo-third absolute bottom-[-1px] "
          viewBox="0 0 1440 126"
          preserveAspectRatio="xMinYMin meet"
        >
          <path d="M685.6,38.8C418.7-11.1,170.2,9.9,0,30v96h1440V30C1252.7,52.2,1010,99.4,685.6,38.8z" />
        </svg>
      </div>
      <div className="bg-logo-third min-h-[150vh] z-50 relative">
        <svg
          className="z-10 fill-logo-second absolute bottom-[-1px] -scale-x-[1]"
          viewBox="0 0 1440 126"
          preserveAspectRatio="xMinYMin meet"
        >
          <path d="M685.6,38.8C418.7-11.1,170.2,9.9,0,30v96h1440V30C1252.7,52.2,1010,99.4,685.6,38.8z" />
        </svg>

        {/* <div className="h-48 w-48 ml-24 mask -z-20 rounded-full relative background-gradient blur-2xl duration-1000 hover:rotate-180">
                    <div className="w-12 h-12 rounded-full blur-none -z-10 absolute translate-[-50%, -50%] top-[50%] opacity-100 left-[50%] bg-logo-second"></div>
                </div> */}

        {/* <div className="max-w-[1400px] mx-auto px-24 overflow-hidden">
                    <div id="testimonials" className="flex gap-8 text-white">
                        {constants.TESTIMONIALS?.map((t) => <div>
                            {t.quote}
                        </div>)}
                    </div>

                </div> */}
        <div
          className={`px-10 justify-center gap-x-6 min-[1700px]:gap-x-16 min-[900px]:grid py-16 -z-10 ${
            windowSize > 1300 ? "hero-preview" : ""
          }`}
          style={{ gridTemplateColumns: "40% 60%" }}
        >
          {windowSize > 1300 ? (
            <div className="hero-preview-animation">
              <div className="hero-preview-animation-line"></div>
            </div>
          ) : null}
          <div className="flex  flex-col gap-y-4 z-20 relative text-white min-[900px]:pl-16 pb-12">
            {/* <div className="max-[450px]:w-[110%] absolute z-10 h-[40vh] w-[85%]  -mt-16 ">
                            <div id="topright" className="g-right absolute w-0 left-[50%] h-[2px]  duration-1000"></div>
                            <div id="topleft" className="g-left absolute w-0 right-[50%] h-[2px]  duration-1000"></div>
                            <div id="left" className="bg-[#81817f] absolute w-[2px] left-0 h-0  duration-2000"></div>
                            <div id="right" className="bg-[#5e658a] absolute w-[2px] right-0 h-0  duration-2000"></div>
                            <div id="bottomright" className="g-right absolute w-0 bottom-0 right-0 h-[2px]  duration-1000"></div>
                            <div id="bottomleft" className="g-left absolute w-0 bottom-0 left-0 h-[2px]  duration-1000"></div>
                        </div> */}
            <div className=" max-[450px]:max-w-[100%] max-w-[50%] lg:max-w-[20vw] lg:max-h-[40vh] max-h-[50vh]  aspect-[1/1] overflow-clip z-30  mb-6">
              <img
                src={headshot}
                className="h-full w-full object-cover rounded-2xl"
              />
            </div>
            <h2 className="text-3xl font-light">{agentName}</h2>
            {/* <p className="italic text-lg">{constants.AGENT_TITLE}, {constants.BROKERAGE}</p> */}

            <div className="flex gap-x-5 my-2">
              {Object.entries(constants.SOCIALS ?? {})?.map(([k, v], index) => (
                <a href={constants.SOCIALS[k]}>
                  <FontAwesomeIcon
                    className="fa-xl "
                    style={{ color: colours[index] }}
                    icon={constants.ICONS[k]}
                  />
                </a>
              ))}
            </div>
            <p className="font-semibold text-lg">
              <FontAwesomeIcon
                style={{ color: colours[0] }}
                icon={faPhone}
                className="pr-2 text-white"
              />
              {agentNumber}{" "}
            </p>
            <p className="text-lg">
              <FontAwesomeIcon
                style={{ color: colours[0] }}
                icon={faEnvelope}
                className="pr-2 text-white"
              />
              {agentEmail}{" "}
            </p>
          </div>
          <div className="flex flex-col text-white text-xl min-[900px]:pr-[10%] z-20 relative">
            <h1
              style={{ fontWeight: "200" }}
              className="text-5xl text-unset text-white pb-8  libre tracking-wide z-10 mb-3"
            >
              Your Trusted Realtor
            </h1>

            {about ? (
              about.split("<|>").map((p) => (
                <p>
                  {p}
                  <br />
                  <br />
                </p>
              ))
            ) : (
              <p>Coming Soon</p>
            )}
            <div className="flex gap-x-4">
              {/* <btn onClick={() => contact.current.scrollIntoView()} className='btn-primary self-start mt-5 '>CONTACT US</btn> */}
              <Link className="btn-tertiary self-start mt-5 " to={"/about"}>
                <btn>Why Choose {agentName?.split(" ")[0]}</btn>
              </Link>
            </div>
          </div>
        </div>
        <div className="flex justify-between items-center pb-10 px-10 gap-x-5 max-w-[1900px] mx-auto text-white">
          <h1
            style={{ fontWeight: "200" }}
            className={`text-4xl libre uppercase ease-in-out duration-2000 slide-in  ${
              windowSize > 700 ? "slide-left" : ""
            }`}
          >
            Featured Listings
          </h1>
          <Link
            className="underline font-semibold underline-offset-4 whitespace-nowrap "
            to={"/listings"}
          >
            View All
          </Link>
        </div>
        <div
          style={{
            gridTemplateColumns: `repeat( auto-fit, minmax(${
              windowSize > 600 ? "450px" : "300px"
            }, 1fr) )`,
          }}
          className="grid px-10  gap-10 pb-36 lg:pb-56  max-w-[1900px] mx-auto"
        >
          {listings?.slice(0, 6)?.map((prop) => (
            <Link className="w-full h-full" to={`/listing/${prop.ListingKey}`}>
              <div className="relative hover:bg-black w-full aspect-[7/8] sm:aspect-[4/3] overflow-hidden group rounded-2xl">
                {/* <img className="w-full h-full object-cover" src={formatted[prop.ListingKey]?.find((img) => img.Order === 0)?.MediaURL ?? formatted[prop.ListingKey]?.[0]?.MediaURL ?? placeholder} /> */}
                <img
                  className="w-full h-full absolute object-cover  group-hover:opacity-50  duration-1000 group-hover:scale-105"
                  src={getListingImage(prop.ListingKey)}
                />
                <div className="absolute flex flex-col w-full h-full z-50 overlay py-4 justify-end gap-y-2">
                  <p
                    style={{ fontWeight: "200" }}
                    className="libre min-[900px]:text-[1.25em] text-[1.25em] text-white px-4"
                  >
                    <FontAwesomeIcon icon={faLocationDot} className="pr-3" />
                    {prop?.StreetNumber} {prop?.StreetName} {prop?.StreetSuffix}
                  </p>

                  <p className="font-semibold text-white text-2xl px-4">
                    {prop.CityRegion ?? prop.CrossStreet}
                  </p>
                  <hr className="border-gradient-2 duration-1000 w-[20%] group-hover:w-[50%] mx-4 my-2"></hr>
                  <div className=" whitespace-nowrap flex-wrap child:px-4  flex ">
                    <div className="border-r-[1px] border-white text-white text-2xl">
                      <span>${prop.ListPrice?.toLocaleString()}</span>
                    </div>
                    <div className="border-r-[1px] border-white text-white text-2xl">
                      <span>{prop.BedroomsTotal} Beds</span>
                    </div>
                    <div className="border-r-[1px] border-white text-white text-2xl">
                      <span>{prop.BathroomsTotalInteger} Baths</span>
                    </div>
                    <div className=" text-white text-2xl">
                      {prop?.LivingAreaRange ? prop.LivingAreaRange : "--"} Sqft
                    </div>
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
      {/* <div className=" bg-logo-second w-full">
                <h1 className="text-4xl text-white py-10 font-mont px-10 uppercase pt-14 max-w-[1700px] mx-auto">Featured Neighbourhoods</h1>

                <div className="grid min-[750px]:grid-cols-2 px-10 max-w-[1700px] mx-auto">
                    {constants.LOCATIONS.slice(0, 4).map((location) =>
                        <Link to={`location/${formattingFunctions.slugify(location.name)}`}>
                            <div className="h-[40vh] relative cursor-pointer overflow-hidden flex items-center justify-center">
                                <img className="absolute h-full  object-cover opacity-75 hover:opacity-50 w-full top-[50%] translate-y-[-50%] hover:scale-105 duration-500 " src={location.img} />
                                <h1 className="text-3xl  text-white py-8 font-mont px-10 uppercase z-10">{location.name}</h1>

                            </div>
                        </Link>
                    )}


                </div>

            </div> */}
      {/* <div className=" pb-24 bg-slate-800">

                <div className="flex justify-between items-center mx-auto max-w-[1500px] px-7 ">

                    <h1 className="text-4xl text-white py-8 font-mont ">OUR AGENTS</h1>
                    <Link className="underline font-semibold underline-offset-4 text-white" to={"/agents"}>View All</Link>
                </div>
                <div className='mx-auto max-w-[1500px] px-7 h-[40vh] sm:h-[30vh] md:h-[45vh]' >

                    <Swiper
                        style={{ "--swiper-pagination-color": "white", "--swiper-button-prev": 'white', '--swiper-pagination-bullet-inactive-color': '#f1f1f1', '--swiper-theme-color': 'lightgrey' }}
                        slidesPerView={1}
                        spaceBetween={50}
                        pagination={{
                            clickable: true,
                        }}
                        navigation={true}
                        loop={true}
                        loopPreventsSliding={true}

                        autoplay={{
                            delay: 7500,
                            disableOnInteraction: true,
                            pauseOnMouseEnter: true
                        }}
                        modules={[Pagination, Autoplay, Navigation]}
                        breakpoints={{

                            640: {
                                spaceBetween: 30,
                                slidesPerView: 2
                            },
                            950: {
                                spaceBetween: 50,
                                slidesPerView: 3
                            },

                        }}


                    >

                        {
                            constants.AGENTS?.map((agent, index) =>
                                <SwiperSlide key={index} >

                                    <div className=' h-[40vh] sm:h-[30vh] md:h-[45vh]' >
                                        <Link className="w-full " state={agent} to={`agents/${slugify(agent.name)}`}>
                                            <div className="relative w-full aspect-[5/3] sm:aspect-[4/3] overflow-hidden group">
                                                <img className="w-full h-full object-cover" src={agent.img ?? placeholder} />
                                                <div className="px-4 py-2 duration-1000 h-[100px] bg-logo-second bg-opacity-50 absolute bottom-0 w-full text-white group-hover:h-full">
                                                    <p className="text-xl font-mont font-semibold">{agent.name}</p>
                                                    <p className=" italic">{agent.title}</p>
                                                    <div className="flex gap-x-4 mt-2">
                                                        {Object.entries(agent.socials ?? {})?.map(([k, v], index) =>
                                                            <a href={v}>
                                                                <FontAwesomeIcon className="fa-lg" icon={constants.ICONS[k]} />

                                                            </a>
                                                        )}
                                                    </div>
                                                    <p className="mt-7 text-xl font-semibold">About {agent.name?.split(' ')[0]}</p>
                                                    <p className="mt-3">{agent.bio ? agent.bio.replace(/(<([^>]+)>)/gi, '')?.split(' ')?.splice(0, windowSize > 950 && windowSize < 1500 ? 20 : 50)?.join(' ') + " ..." : 'Coming Soon'}</p>
                                                </div>
                                            </div>

                                        </Link>
                                    </div>
                                </SwiperSlide>


                            )
                        }

                    </Swiper>
                </div>
                <div className="grid mx-auto mt-12 sm:grid-cols-3 w-fit gap-x-12 gap-y-12 child:max-w-64 child:flex child:flex-col child:gap-y-5 child:text-center ">
                    <div>
                        <FontAwesomeIcon icon={faAward} className="fa-5x text-med-grey " />
                        <span className="text-med-grey font-semibold text-2xl">2022</span>
                        <span className="text-white font-semibold text-xl">Best Realtor Toronto</span>
                    </div>
                    <div>
                        <FontAwesomeIcon icon={faStar} className="fa-5x text-med-grey" />
                        <span className="text-med-grey font-semibold text-2xl">2023</span>
                        <span className="text-white font-semibold text-xl">Most Houses Sold</span>
                    </div>
                    <div>
                        <FontAwesomeIcon icon={faAward} className="fa-5x text-med-grey" />
                        <span className="text-med-grey font-semibold text-2xl">2019</span>
                        <span className="text-white font-semibold text-xl">Favourite Realtor </span>
                    </div>





                </div>
              
            </div> */}
      <div className="bg-logo-main px-10">
        {/* <h1 className="text-4xl text-white py-10 pt-20 font-mont text-center uppercase">Unsure about the next step? Let us help</h1>

                <div className="py-10 grid grid-cols-2 gap-24 max-w-[1000px] mx-auto">
                    <div className="h-[40vh] relative cursor-pointer overflow-hidden flex items-center justify-center">
                        <img className="absolute h-full object-cover opacity-75 hover:opacity-50 w-full top-[50%] translate-y-[-50%] hover:scale-105 duration-500 " src={house} />
                        <h1 className="text-3xl  text-white py-8 font-mont px-14 text-center uppercase z-10">I am looking to buy</h1>

                    </div>
                    <div className="h-[40vh] relative cursor-pointer overflow-hidden flex items-center justify-center">
                        <img className="absolute h-full object-cover opacity-75 hover:opacity-50 w-full top-[50%] translate-y-[-50%] hover:scale-105 duration-500 " src={house} />
                        <h1 className="text-3xl  text-white py-8 font-mont px-14 text-center uppercase z-10">I am Looking to Sell</h1>

                    </div>


                </div> */}

        {/* 
                <h1 className="text-4xl text-logo-second py-10 pt-18  text-center libre">Unsure About The Next Step? Let Us Help</h1>

                <div className="py-10 pb-32 grid min-[750px]:grid-cols-2 min-[1100px]:gap-24 gap-12 max-w-[1000px] mx-auto">
                    <Link to={'/listings'} className="h-[40vh] bg-black relative cursor-pointer overflow-hidden flex items-center justify-center">
                        <img className="absolute h-full object-cover opacity-25 hover:opacity-50 w-full top-[50%] translate-y-[-50%] hover:scale-105 duration-500 " src={houseInterior} />
                        <h1 className="text-3xl  text-logo-main py-8 libre px-14 text-center uppercase z-10">I am looking to buy</h1>

                    </Link>
                    <Link to={'/evaluation'} className="h-[40vh] bg-black relative cursor-pointer overflow-hidden flex items-center justify-center">
                        <img className="absolute h-full object-cover opacity-25 hover:opacity-50 w-full top-[50%] translate-y-[-50%] hover:scale-105 duration-500 " src={houseInterior2} />
                        <h1 className="text-3xl  text-logo-main py-8 libre px-14 text-center uppercase z-10">I am Looking to Sell</h1>

                    </Link>


                </div> */}
      </div>
      <div className="w-full bg-logo-second z-10 relative">
        <div className="max-w-[1900px] mx-auto px-10 text-white pb-10">
          <h1
            style={{ fontWeight: "200" }}
            className={`text-4xl py-12 libre uppercase ease-in-out duration-2000 slide-in ${
              windowSize > 700 ? "slide-left" : ""
            }`}
          >
            Useful Tools
          </h1>

          <div className="grid md:grid-cols-3 gap-10 child:overflow-hidden   mb-10">
            <Link className="group" to={"/calculator"}>
              <div className="overflow-hidden h-96 rounded-2xl">
                <img
                  className="h-full w-full object-cover group-hover:scale-105 duration-700"
                  src={calc}
                />
              </div>
              <hr className="border-gradient-2 duration-1000 w-[20%] group-hover:w-[50%] mt-6 my-2"></hr>

              <h3 className="text-2xl pt-2 pb-2 ">Mortgage Calculator</h3>
              <span className="">
                Find a price range that works with your budget by using our
                Mortgage Calculator
              </span>
            </Link>
            <Link className="group" to={"/real-estate-reports"}>
              <div className="overflow-hidden h-96 rounded-2xl">
                <img
                  className="h-full w-full object-cover group-hover:scale-105 duration-700"
                  src={report}
                />
              </div>
              <hr className="border-gradient-2 duration-1000 w-[20%] group-hover:w-[50%] mt-6 my-2"></hr>

              <h3 className="text-2xl pt-2 pb-2 ">Real Estate Reports</h3>
              <span className="">
                Gain valuable insights into the market with our free Real Estate
                Reports
              </span>
            </Link>
            <Link className="group" to={"/evaluation"}>
              <div className="overflow-hidden h-96 rounded-2xl">
                <img
                  className="h-full w-full object-cover group-hover:scale-105 duration-700"
                  src={house2}
                />
              </div>
              <hr className="border-gradient-2 duration-1000 w-[20%] group-hover:w-[50%] mt-6 my-2"></hr>

              <h3 className="text-2xl pt-2 pb-2 ">Home Evaluation</h3>
              <span className="">
                How much is your home worth in today's market? Find out with our
                free Home Evaluation
              </span>
            </Link>
          </div>
        </div>
      </div>
      <div
        ref={contact}
        className="w-full bg-logo-second text-white z-10 relative flex flex-wrap gap-x-16 gap-y-10 justify-center py-16 px-7 "
      >
        <div>
          <h4 className=" font-semibold text-lg min-w-[20vw]">
            Questions? We're Here To Help
          </h4>
          <form onSubmit={submitForm} className="mt-6 flex flex-col">
            <div className="form-item">
              <label className="form-label">Name*</label>
              <input 
                className={`form-input ${formErrors.Name ? 'border-red-500' : ''}`}
                name="Name"
                placeholder="Full Name"
                value={formData.Name}
                onChange={handleInputChange}
              />
              {formErrors.Name && (
                <p className="text-red-500 text-sm mt-1">{formErrors.Name}</p>
              )}
            </div>
            <div className="form-item">
              <label className="form-label">Email*</label>
              <input
                className={`form-input ${formErrors["Email Address"] ? 'border-red-500' : ''}`}
                name="Email Address"
                placeholder="Email Address"
                value={formData["Email Address"]}
                onChange={handleInputChange}
              />
              {formErrors["Email Address"] && (
                <p className="text-red-500 text-sm mt-1">{formErrors["Email Address"]}</p>
              )}
            </div>
            <div className="form-item">
              <label className="form-label">Message*</label>
              <textarea
                className={`form-input resize-none h-32 ${formErrors.Message ? 'border-red-500' : ''}`}
                name="Message"
                placeholder="Your Message"
                value={formData.Message}
                onChange={handleInputChange}
              />
              {formErrors.Message && (
                <p className="text-red-500 text-sm mt-1">{formErrors.Message}</p>
              )}
            </div>
            <button 
              type="submit" 
              className="btn-tertiary self-start px-10"
              disabled={isSubmitting}
            >
              {isSubmitting ? 'Sending...' : 'Send'}
            </button>
          </form>
        </div>
        <div>
          <iframe
            class="contact-map"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2885.1670922064877!2d-79.3108446!3d43.686289499999994!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89d4cc14ec855631%3A0xb3d0feb68a2d0ed3!2s85%20Cedarvale%20Ave%2C%20Toronto%2C%20ON%20M4C%204J7!5e0!3m2!1sen!2sca!4v1730912488107!5m2!1sen!2sca"
            height="365"
            width={`${windowSize > 900 ? "500" : "300"}`}
            style={{ border: 0 }}
            allowfullscreen=""
            loading="lazy"
            referrerpolicy="no-referrer-when-downgrade"
          ></iframe>

          <div className="flex flex-col gap-y-2 mt-6">
            <h2 className="text-2xl">{agentName}</h2>
            {/* <p className="italic">{constants.AGENT_TITLE}, {constants.AGENT}</p> */}
            <p>
              <FontAwesomeIcon icon={faPhone} className="text-white fa-lg" />{" "}
              {agentNumber}{" "}
            </p>
            <p>
              <FontAwesomeIcon icon={faEnvelope} className="text-white fa-lg" />{" "}
              {agentEmail}{" "}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
